import { FETCH_INSTITUTION_CREDENTILAS_DATA } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

const reducer = hOReducer(FETCH_INSTITUTION_CREDENTILAS_DATA);
export default reducer;
